import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { TicketGroupsProvider } from './TicketGroupsContext';
import { TicketGroupEditProvider, useTicketGroupEdit } from './TicketGroupEditContext';
import TicketGroupsList from './components/TicketGroupsList';

const EventTicketTypesFormContent = () => {
  const location = useLocation();
  const history = useHistory();
  const { setIsAddingTicketGroup } = useTicketGroupEdit();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('openAddTicketGroup') === 'true') {
      setIsAddingTicketGroup(true);
      urlParams.delete('openAddTicketGroup');
      const newSearch = urlParams.toString();
      history.replace({
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : '',
      });
    }
  }, [location.search, history, location.pathname, setIsAddingTicketGroup]);

  return (
    <>
      <TicketGroupsList />
    </>
  );
};

const EventTicketTypesForm = () => {
  return (
    <TicketGroupsProvider>
      <TicketGroupEditProvider>
        <EventTicketTypesFormContent />
      </TicketGroupEditProvider>
    </TicketGroupsProvider>
  );
};

export default EventTicketTypesForm;
